import React, { createContext, useContext } from 'react';
import { injectStripe, StripeProvider as StripeProvider$1, Elements } from 'react-stripe-elements';

var Context = createContext();

var useStripe = function useStripe() {
  return useContext(Context);
};

var HookProvider = function HookProvider(_ref) {
  var children = _ref.children,
      stripe = _ref.stripe;
  return React.createElement(Context.Provider, {
    value: stripe
  }, children);
};

var StripeHookProvider = injectStripe(HookProvider);

var StripeProvider = function StripeProvider(_ref2) {
  var apiKey = _ref2.apiKey,
      children = _ref2.children;
  return React.createElement(StripeProvider$1, {
    apiKey: apiKey
  }, React.createElement(Elements, null, React.createElement(StripeHookProvider, null, children)));
};

export { StripeHookProvider, StripeProvider, useStripe };
//# sourceMappingURL=index.es.js.map
